import React from 'react';
import { Route, Switch } from 'react-router';
import { AppContainer } from 'react-hot-loader';

// Routes
import FourOhFour from 'components/404';
import Home from 'components/home';
import Indicator from 'components/indicator';
import LandingPage from 'components/landingPage';
import Geography from 'components/geography';

// Components
import Header from 'components/header';

// Styles
import styles from './app.scss';

const App = () => (
  <AppContainer>
    <div className={styles.app}>
      <Route component={Header} path="/:category?" />
      <Switch>
        <Route component={Home} path="/" exact />
        <Route
          component={Indicator}
          path="/:renderType?/:category/indicator/:indicatorName?"
        />
        <Route
          component={Geography}
          path="/:renderType?/:category/geography/:geography"
        />
        <Route
          component={LandingPage}
          path="/:category?"
        />
        <Route component={FourOhFour} />
      </Switch>
    </div>
  </AppContainer>
);

export default App;



// WEBPACK FOOTER //
// ./app/components/app/index.js